export const appsData = [
  {
    slug: 'block-drop',
    name: 'Block Drop',
    packageName: 'com.rivenbyte.blockdrop',
    platform: 'android',
    category: 'Puzzle',
    description: 'A satisfying block-stacking puzzle game. Stack falling blocks to clear rows and achieve high scores.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.rivenbyte.blockdrop',
    icon: '🟦',
    accentColor: '#3498DB',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob', 'Google Fonts'],
    contact: 'paulnkingwa34@gmail.com',
  },
  {
    slug: 'drop-four',
    name: 'Drop Four: Connect 4 Puzzle',
    packageName: 'com.rivenbyte.dropfour',
    platform: 'android',
    category: 'Puzzle',
    description: 'A modern take on the classic Connect Four game. Drop discs and connect four in a row to win!',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.rivenbyte.dropfour',
    icon: '🔴',
    accentColor: '#E74C3C',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob'],
    contact: 'paulnkingwa34@gmail.com',
  },
  {
    slug: 'jumpy-neon',
    name: 'Jumpy Neon: Retro Arcade Game',
    packageName: 'com.rivenbyte.jumpy.neon',
    platform: 'android',
    category: 'Arcade',
    description: 'A neon-lit retro arcade platformer. Jump, dodge, and survive through glowing obstacles in a cyberpunk world.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.rivenbyte.jumpy.neon',
    icon: '⚡',
    accentColor: '#00FFAA',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob'],
    contact: 'paulnkingwa34@gmail.com',
  },
  {
    slug: 'neon-crossword',
    name: 'Neon Crossword',
    packageName: 'com.rivenbyte.neoncrossword',
    platform: 'android',
    category: 'Word',
    description: 'A glowing neon-themed crossword puzzle game. Challenge your vocabulary and complete grids in a vibrant neon style.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.rivenbyte.neoncrossword',
    icon: '💡',
    accentColor: '#9B59B6',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob'],
    contact: 'paulnkingwa34@gmail.com',
  },
  {
    slug: 'neon-dash',
    name: 'Neon Dash',
    packageName: 'com.rivenbyte.neondash',
    platform: 'android',
    category: 'Arcade',
    description: 'High-speed neon dash arcade game. Run, jump, and slide through neon-lit obstacles at breakneck speed.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.rivenbyte.neondash',
    icon: '🏃',
    accentColor: '#FF6B35',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob'],
    contact: 'paulnkingwa34@gmail.com',
  },
  {
    slug: 'neon-solitaire',
    name: 'Neon Solitaire',
    packageName: 'com.rivenbyte.neonsolitaire',
    platform: 'android',
    category: 'Card',
    description: 'Classic Klondike Solitaire with a stunning neon visual style. Relax and clear the deck in glowing neon colors.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.rivenbyte.neonsolitaire',
    icon: '🃏',
    accentColor: '#F39C12',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob'],
    contact: 'paulnkingwa34@gmail.com',
  },
  {
    slug: 'sala-takatifu',
    name: 'Sala Takatifu',
    packageName: 'com.salatakatifu.app',
    platform: 'android',
    category: 'Faith & Prayer',
    description: 'A Catholic prayer companion app featuring novena prayers, daily devotions, and spiritual content in Swahili and English.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.salatakatifu.app',
    icon: '✝️',
    accentColor: '#00d4aa',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: ['Prayer progress (stored locally)', 'Theme preference (stored locally)'],
    sdks: ['Google AdMob', 'Google Fonts'],
    contact: 'salatakatifu@gmail.com',
    customPrivacyPath: '/sala-takatifu/privacy',
  },
  {
    slug: 'docblade',
    name: 'DocBlade: PDF Editor & Tools',
    packageName: 'com.docblade.app',
    platform: 'android',
    category: 'Productivity',
    description: '100% offline PDF editor — edit, convert, scan, merge, split, sign, and compress PDFs entirely on your device. Zero data collected.',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.docblade.app',
    icon: '📄',
    accentColor: '#2563EB',
    usesAds: false,
    usesAdMob: false,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['None — fully offline, no third-party SDKs'],
    contact: 'paulnkingwa34@gmail.com',
    customPrivacyPath: '/docblade/privacy',
  },
  {
    slug: 'slingshot-showdown',
    name: 'Slingshot Showdown',
    packageName: 'com.slingshotshowdown.game',
    platform: 'android',
    category: 'Action',
    description: 'A physics-based slingshot battle game. Aim, sling, and knock out opponents in exciting physics-driven duels!',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.slingshotshowdown.game',
    icon: '🎯',
    accentColor: '#E74C3C',
    usesAds: true,
    usesAdMob: true,
    collectsData: false,
    hasAccounts: false,
    hasPurchases: false,
    dataTypes: [],
    sdks: ['Google AdMob'],
    contact: 'paulnkingwa34@gmail.com',
  },
];

export const getAppBySlug = (slug) => appsData.find(a => a.slug === slug);

export const ossGames = [
  {
    id: 'oss-2048',
    title: '2048',
    author: 'Gabriele Cirulli',
    desc: 'The original addictive 2048 number-merging puzzle that took the world by storm.',
    emoji: '🔢',
    genre: 'Number Puzzle',
    color: 'from-yellow-600 to-amber-800',
    accent: '#F39C12',
    liveUrl: 'https://gabrielecirulli.github.io/2048/',
    repoUrl: 'https://github.com/gabrielecirulli/2048',
    license: 'MIT',
  },
  {
    id: 'oss-asteroids',
    title: 'Asteroids',
    author: 'Doug McInnes',
    desc: 'Pure JavaScript recreation of the classic 1979 Atari arcade shooter.',
    emoji: '🚀',
    genre: 'Shoot \'em Up',
    color: 'from-slate-700 to-gray-900',
    accent: '#95A5A6',
    liveUrl: 'https://dmcinnes.github.io/HTML5-Asteroids/',
    repoUrl: 'https://github.com/dmcinnes/HTML5-Asteroids',
    license: 'Unlicense',
  },
  {
    id: 'oss-pacman',
    title: 'Pac-Man',
    author: 'Platzhersh',
    desc: 'The beloved maze-chase arcade classic, faithfully re-written in HTML5 Canvas.',
    emoji: '👻',
    genre: 'Maze / Chase',
    color: 'from-yellow-500 to-orange-700',
    accent: '#FFD700',
    liveUrl: 'https://platzhersh.github.io/pacman-canvas/',
    repoUrl: 'https://github.com/platzhersh/pacman-canvas',
    license: 'MIT',
  },
  {
    id: 'oss-flappy',
    title: 'Flappy Bird',
    author: 'CodeExplained',
    desc: 'The infuriatingly fun tap-to-fly game — made with pure HTML5 Canvas.',
    emoji: '🐦',
    genre: 'Reaction / Endless',
    color: 'from-sky-500 to-blue-800',
    accent: '#3498DB',
    liveUrl: 'https://codeexplainedrepo.github.io/FlappyBird-JavaScript/',
    repoUrl: 'https://github.com/CodeExplainedRepo/FlappyBird-JavaScript',
    license: 'MIT',
  },
  {
    id: 'oss-tower',
    title: 'Tower Stack',
    author: 'iamkun',
    desc: 'Stack blocks with perfect precision to build the tallest tower you can!',
    emoji: '🏗️',
    genre: 'Skill / Stack',
    color: 'from-teal-600 to-emerald-900',
    accent: '#1ABC9C',
    liveUrl: 'https://iamkun.github.io/tower_game/',
    repoUrl: 'https://github.com/iamkun/tower_game',
    license: 'MIT',
  },
  {
    id: 'oss-solitaire',
    title: 'Solitaire',
    author: 'Warpdesign',
    desc: 'Classic Klondike Solitaire in an elegant HTML5 browser experience.',
    emoji: '🃏',
    genre: 'Card Game',
    color: 'from-green-700 to-green-900',
    accent: '#27AE60',
    liveUrl: 'https://warpdesign.github.io/html5-solitaire-js/',
    repoUrl: 'https://github.com/warpdesign/html5-solitaire-js',
    license: 'MIT',
  },
  {
    id: 'oss-sudoku',
    title: 'Sudoku',
    author: 'amit0-git',
    desc: 'Clean, responsive Sudoku puzzle with multiple difficulty levels.',
    emoji: '🔲',
    genre: 'Logic Puzzle',
    color: 'from-indigo-700 to-purple-900',
    accent: '#8E44AD',
    liveUrl: 'https://amit0-git.github.io/Sudoku/',
    repoUrl: 'https://github.com/amit0-git/Sudoku',
    license: 'MIT',
  },
  {
    id: 'oss-minesweeper',
    title: 'Minesweeper',
    author: 'michaelbutler',
    desc: 'WebWorker-powered Minesweeper — flag all mines without hitting one!',
    emoji: '💣',
    genre: 'Strategy / Puzzle',
    color: 'from-gray-600 to-gray-900',
    accent: '#7F8C8D',
    liveUrl: 'https://michaelbutler.github.io/minesweeper/',
    repoUrl: 'https://github.com/michaelbutler/minesweeper',
    license: 'MIT',
  },
  {
    id: 'oss-breakout',
    title: 'Breakout',
    author: 'Jake Gordon',
    desc: 'HTML5 Canvas Breakout — break all the bricks with your bouncing ball!',
    emoji: '🧱',
    genre: 'Arcade / Ball',
    color: 'from-red-700 to-rose-900',
    accent: '#E74C3C',
    liveUrl: 'https://codeincomplete.com/games/breakout/v6/',
    repoUrl: 'https://github.com/jakesgordon/javascript-breakout',
    license: 'MIT',
  },
  {
    id: 'oss-pong',
    title: 'Pong',
    author: 'SMenigat',
    desc: 'The game that started it all — classic two-player Pong in your browser.',
    emoji: '🏓',
    genre: 'Classic Arcade',
    color: 'from-zinc-600 to-black',
    accent: '#ECF0F1',
    liveUrl: 'https://smenigat.github.io/html5-pong/',
    repoUrl: 'https://github.com/SMenigat/html5-pong',
    license: 'MIT',
  },
];
